import { FormikProps, getIn } from 'formik';
import _ from 'lodash';
import React from 'react';

import { DeleteIconButton } from 'packages/common-frontend/components/IconButton';

export const DeletePropertyButton: React.FC<{
  formProps: FormikProps<any>;
  basePropertyKey: string;
  propertyKey: string;
}> = ({ formProps, basePropertyKey, propertyKey }) => {
  const propertySection = getIn(formProps.values, basePropertyKey);
  const updatedPropertySection = _.omit(propertySection, propertyKey);
  return (
    <DeleteIconButton
      ariaLabel="delete"
      label="Delete"
      onClick={(event) => {
        if (event) {
          event.stopPropagation();
        }
        return formProps.setFieldValue(basePropertyKey, updatedPropertySection);
      }}
    />
  );
};
